import { render, staticRenderFns } from "./choose-agency.vue?vue&type=template&id=39dbfb96&scoped=true"
import script from "./choose-agency.vue?vue&type=script&lang=js"
export * from "./choose-agency.vue?vue&type=script&lang=js"
import style0 from "./choose-agency.vue?vue&type=style&index=0&id=39dbfb96&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbfb96",
  null
  
)

export default component.exports